/**
 * TimeSlotGridSkeleton - Placeholder for the slot grid while availability loads.
 * Mirrors TimeSlotSegment's header row + pill grid so the layout doesn't jump.
 */

import { Skeleton } from '@butter/ui/primitives';

const SEGMENTS = [0, 1];
const CELLS = Array.from({ length: 10 }, (_, i) => i);

export function TimeSlotGridSkeleton() {
  return (
    <div
      role="status"
      aria-label="Loading time slots"
      data-testid="time-slots-skeleton"
      className="space-y-8 pt-3"
    >
      <span className="sr-only">Loading time slots</span>
      {SEGMENTS.map((segment) => (
        <div key={segment} className="space-y-4" aria-hidden="true">
          <div className="flex items-center gap-2">
            <Skeleton className="size-5 rounded-full" />
            <Skeleton className="h-4 w-24" />
          </div>
          <div className="grid grid-cols-3 gap-2 sm:gap-3 md:grid-cols-4 lg:grid-cols-5">
            {CELLS.map((cell) => (
              <Skeleton key={cell} className="h-11 rounded-full" />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
